import { gql } from '@apollo/client';

export const GET_PAYMENTS_CONFIG = gql`
  query get_payments_config($data: GetPaymentsConfigInputType) {
    get_payments_config(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const CREATE_BILLING_PORTAL_SESSION = gql`
  mutation create_billing_portal_session(
    $data: CreateBillingPortalSessionInputType
  ) {
    create_billing_portal_session(data: $data) {
      hasError
      data
      message
    }
  }
`;
